import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SdexAdminService } from 'src/app/share/services/sdex/sdex-admin.service';
import { MessageService } from 'src/app/share/sharedsubject';

@Component({
    selector: 'app-accept-reject-confirmation-modal',
    templateUrl: './accept-reject-confirmation-modal.component.html',
    styleUrls: ['./accept-reject-confirmation-modal.component.scss'],
    standalone: false
})
export class AcceptRejectConfirmationModalComponent {
  @Input() acceptRejectData!: 'Accept' | 'Reject';
  @Input() invitationId: any;
  @Input() companyActivated: any;
  @Input() branchName: string; 
  @Input() tyreDetails: any; 
  isLoading  : boolean= false;

  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly _service: SdexAdminService,
    private readonly messageService: MessageService) { }

  closeDialog() {
    this.activeModal.close();
  }

  confirmation(type: 'Accept' | 'Reject' | 'isActivated') {
    this.isLoading = true;
    if (type === 'Accept') {
      this._service
        .acceptInvitation(this.invitationId)
        .subscribe((res: any) => {
          this.isLoading = false;
          setTimeout(() => {
            this.messageService.sendMessage(res.message);
          })
          this.activeModal.close({
            status: true,
            message: res.message,
          });
        });
    } else if (type === 'Reject') {
      this.isLoading = true;
      this._service
        .rejectInvitation(this.invitationId)
        .subscribe((res: any) => {
          this.isLoading = false;
          setTimeout(() => {
            this.messageService.sendMessage(res.message);
          })
          this.activeModal.close({
            status: true,
            message: res.message,
          });
        });
    } else {
      this.activeModal.close({
        status: true,
        message: 'company list Activated',
      });
    }
  }
}
